module.exports = __webpack_public_path__ + "static/techbg-f91fc59ab99943e362e29a98c4be16de.png";